exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-authority[data-v-0a6b4866]{width:100%;height:10.66667rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[data-v-0a6b4866] .ant-empty-image{height:5.33333rem!important}[data-v-0a6b4866] .ant-empty-description{font-size:.48rem}", ""]);

// exports
